import { render, staticRenderFns } from "./AddAboutUs.vue?vue&type=template&id=24b277d2&scoped=true&"
import script from "./AddAboutUs.vue?vue&type=script&lang=js&"
export * from "./AddAboutUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b277d2",
  null
  
)

export default component.exports